import { http, ep } from '../../client/http';

export const investorRelationsRepo = {
  get: async () => {
    const res = await http.get(ep('investorRelations/list?limit=20'), {
      params: { status: true }
    });
    return res.data.data;
  }
};
